import {gql, useQuery} from "@apollo/client";
import {useContext} from "react";
import {useLogger} from "./useLogger";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getCountries($locale: String!) {
  countryCollection(locale: $locale) {
    items {
      country
      countryCode
    }
  }
}`;


export const useCountries = (slug) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: { slug: slug, locale: localeUppercase}, errorPolicy: "all"});
    const countries = new Map();

    data?.countryCollection?.items?.forEach((country) => {
        countries.set(country?.countryCode, country?.country);
    });

    if (error?.message) {
        logger(error?.message, "error", "useCountries", error?.stack);
    }

    return {
        countries,
        countriesLoading: loading,
        error
    };
};
